import { PaymentService } from "src/app/shared/services/payment.service";
import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Helper } from "src/app/core/helpers/helper";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-add-amount-modal",
  templateUrl: "./add-amount-modal.component.html",
  styleUrl: "./add-amount-modal.component.scss",
  standalone: false
})
export class AddAmountModalComponent implements OnInit {
  form!: UntypedFormGroup;
  modalRef!: NgbModalRef;
  modalConfig: any = { centered: true, backdrop: "static" };

  @Output() addEvent = new EventEmitter();
  @ViewChild("template", { static: true }) template!: TemplateRef<any>;

  constructor(private modalService: NgbModal, private formBuilder: UntypedFormBuilder, private paymentService: PaymentService, public helper: Helper) {}

  /**
   * Initializes the component and sets up the form.
   */
  ngOnInit(): void {
    this.initForm();
  }

  /**
   * Opens the modal dialog with the specified configuration.
   * Sets up the result handling for the modal.
   */
  openModal(): void {
    this.modalRef = this.modalService.open(this.template, this.modalConfig);
    this.modalRef.result.then(
      () => this.closeModal(),
      () => this.closeModal()
    );
  }

  /**
   * Initializes the form with validation rules.
   */
  initForm(): void {
    this.form = this.formBuilder.group({
      amount: [null, [Validators.required, this.helper.minValueValidator(1)]]
    });
  }

  /**
   * Handles the form submission for adding wallet amount.
   * Emits the addEvent with the trimmed amount value if the form is valid.
   * Closes the modal after submission.
   */
  submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.addEvent.emit(Number(this.amountInput.value.trim()));
    this.closeModal();
  }

  /**
   * Validates the number input to ensure only numeric values are entered.
   * Sanitizes the input value to remove any non-numeric characters.
   *
   * @param event The input event triggered by the user.
   */
  validateNumberInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const sanitizedValue = input.value.replace(/[^0-9.]/g, "").replace(/(\..*?)\..*/g, "$1");
    input.value = sanitizedValue;
    this.amountInput.setValue(sanitizedValue);
  }

  /**
   * Closes the modal dialog and resets the form.
   * Dismisses the modal with the reason 'Cross click'.
   */
  closeModal(): void {
    this.modalRef?.dismiss();
    this.form.reset();
  }

  /**
   * Gets the form control for the amount input field.
   *
   * @returns The form control for the amount input.
   */
  get amountInput(): any {
    return this.form.get("amount");
  }
}
